export enum EdroNetworkState {
  Stop = 'Stop',
  Pending = 'Pending',
  Running = 'Running',
  InError = 'InError',
}

export enum EdroNetworkErrorCode {
  HorsLigne = 'HorsLigne',
}
